import {
  AutoClearValue
} from '../../../../shared/constants/tile-config.constants';

export class CSVFieldParser {
  static parseBoolean(value?: string): boolean | null {
    if (!value) return null;
    const lower = value.toLowerCase();
    if (lower === 'true') return true;
    if (lower === 'false') return false;
    return null;
  }

  static parseAutoClear(value?: string): AutoClearValue {
    if (!value) return AutoClearValue.Off;
    const lower = value.toLowerCase();
    if (lower === 'all') return AutoClearValue.All;
    if (lower === 'acked') return AutoClearValue.Acked;
    return AutoClearValue.Off;
  }

  static parseNumber(value?: string): number | null {
    if (!value || value.trim() === '') return null;
    const parsed = parseFloat(value);
    return isNaN(parsed) ? null : parsed;
  }

  static parseInt(value?: string): number | null {
    if (!value || value.trim() === '') return null;
    const parsed = parseInt(value, 10);
    return isNaN(parsed) ? null : parsed;
  }

  static parseIdList(value?: string): string[] {
    if (!value) return [];
    return value.split(',').map(id => id.trim()).filter(id => id);
  }
}
